import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Mail, Zap, Users, CheckCircle2 } from 'lucide-react';
export function AntiScamSection() {
  const pillars = [{
    icon: <Lock className="w-8 h-8 text-[#d4af37]" data-id="element-43" />,
    title: 'Pagos 100% Seguros',
    desc: 'Tus pagos son procesados por Mercado Pago con cifrado de nivel bancario. Nosotros nunca vemos ni guardamos tus datos de tarjeta.',
    color: 'border-[#d4af37]/30',
    bg: 'bg-[#d4af37]/5'
  }, {
    icon: <Zap className="w-8 h-8 text-green-400" data-id="element-44" />,
    title: 'Entrega Inmediata',
    desc: 'El sistema es automático. Ni bien se acredita tu pago, recibís un email con el acceso a todo el material para empezar hoy mismo.',
    color: 'border-green-400/30',
    bg: 'bg-green-400/5'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-[#d4af37]" data-id="element-45" />,
    title: 'Garantía de 7 Días',
    desc: 'Si el contenido no es lo que esperabas, tenés una semana para pedir el reembolso total. Tu inversión está protegida por ley.',
    color: 'border-[#d4af37]/30',
    bg: 'bg-[#d4af37]/5'
  }, {
    icon: <Mail className="w-8 h-8 text-blue-400" data-id="element-46" />,
    title: 'Soporte Humano',
    desc: 'No somos un bot. Tenemos un equipo real respondiendo tus dudas por email para que nunca te sientas sola en este camino.',
    color: 'border-blue-400/30',
    bg: 'bg-blue-400/5'
  }];
  return <section className="py-24 px-4 bg-transparent relative overflow-hidden pt-[9px] pb-[9px]" data-id="element-47">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-[#8b7355]/10 to-transparent pointer-events-none" data-id="element-48" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-49">
        <div className="text-center mb-16" data-id="element-50">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-green-500/10 border border-green-500/30 text-green-700 text-sm font-black mb-6 tracking-widest uppercase" data-id="element-51">
            <ShieldCheck className="w-4 h-4" data-id="element-52" />
            Tu seguridad es nuestra prioridad
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black text-[#0f1711] mb-6 tracking-tight leading-tight" data-id="element-53">
            ¿POR QUÉ <span className="text-[#8b7355]" data-id="element-54">NO SOMOS</span> UNA
            ESTAFA?
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-[#3e2723]/70 max-w-3xl mx-auto font-medium" data-id="element-55">
            Sabemos que hay mucha desconfianza en internet. Por eso, queremos
            ser 100% transparentes con vos antes de que tomes cualquier
            decisión.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-56">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-8 rounded-[2.5rem] border ${pillar.color} bg-white shadow-sm hover:scale-[1.02] transition-transform duration-300`} data-id="element-57">
              <div className="flex items-start gap-6" data-id="element-58">
                <div className="p-4 rounded-2xl bg-[#f5f0e1] border border-[#0f1711]/10 shadow-sm" data-id="element-59">
                  {pillar.icon}
                </div>
                <div data-id="element-60">
                  <h3 className="text-2xl font-black text-[#0f1711] mb-3 tracking-tight font-heading" data-id="element-61">
                    {pillar.title}
                  </h3>
                  <p className="text-[#3e2723]/70 leading-relaxed font-medium" data-id="element-62">
                    {pillar.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Social Proof Bar */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border border-[#0f1711]/10 rounded-[3rem] p-8 md:p-12 flex flex-col md:flex-row text-center md:text-left shadow-sm gap-[10px] items-start justify-center" data-id="element-63">
          <div className="flex items-center gap-4" data-id="element-64">
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center" data-id="element-65">
              <Users className="w-8 h-8 text-green-700" data-id="element-66" />
            </div>
            <div data-id="element-67">
              <p className="text-3xl font-black text-[#0f1711]" data-id="element-68">+1,500</p>
              <p className="text-[#3e2723]/60 font-bold uppercase text-xs tracking-widest" data-id="element-69">
                Mujeres crerando recetas
              </p>
            </div>
          </div>

          <div className="h-px w-full md:h-12 md:w-px bg-[#0f1711]/10" data-id="element-70" />

          <div className="flex items-center gap-4" data-id="element-71">
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex flex-row items-center justify-center" data-id="element-72">
              <CheckCircle2 className="w-8 h-8 text-green-700" data-id="element-73" />
            </div>
            <div data-id="element-74">
              <p className="text-3xl font-black text-[#0f1711]" data-id="element-75">100%</p>
              <p className="text-[#3e2723]/60 font-bold uppercase text-xs tracking-widest" data-id="element-76">
                Legal y Transparente
              </p>
            </div>
          </div>

          <div className="h-px w-full md:h-12 md:w-px bg-[#0f1711]/10" data-id="element-77" />

          <div className="flex items-center gap-4" data-id="element-78">
            <div className="w-16 h-16 rounded-full bg-green-500/10 flex items-center justify-center" data-id="element-79">
              <ShieldCheck className="w-8 h-8 text-green-700" data-id="element-80" />
            </div>
            <div data-id="element-81">
              <p className="text-3xl font-black text-[#0f1711]" data-id="element-82">7 DÍAS</p>
              <p className="text-[#3e2723]/60 font-bold uppercase text-xs tracking-widest" data-id="element-83">
                Garantía Total
              </p>
            </div>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-12 text-gray-500 text-sm font-medium italic" data-id="element-84">
          * Recetario Ancestral es una marca registrada. Todos los derechos
          reservados.
        </motion.p>
      </div>
    </section>;
}